import React from 'react';
import CrossRoad from "../UI/Crossroad";

const CrossRoad_14ABlue_SBlue = () => <CrossRoad coords="1990.000000, 1098.000000"/>;

export default CrossRoad_14ABlue_SBlue;
